import React, { forwardRef, useState } from 'react';
import { TextElement } from '@basis-theory/react-elements';
import { useTheme } from '@material-ui/core/styles';
import classNames from 'classnames';

import { styles, useWrapperStyles } from './text.styles';

const BasisTheoryText = forwardRef(function BasisTheoryText(props, ref) {
  const { mode, onFocus: externalOnFocus, onBlur: externalOnBlur, ...textProps } = props;
  const [isFocused, setIsFocused] = useState(false);
  const theme = useTheme();
  const inlineStyles = styles(theme);
  const classes = useWrapperStyles();

  const handleFocus = (e) => {
    setIsFocused(true);
    externalOnFocus?.(e);
  };

  const handleBlur = (e) => {
    setIsFocused(false);
    externalOnBlur?.(e);
  };

  return (
    <div className={classNames(classes.wrapper, { [classes.wrapperFocused]: isFocused })}>
      <TextElement
        {...textProps}
        ref={ref}
        style={mode === 'dark' ? inlineStyles.textElementStyleDark : inlineStyles.textElementStyleLight}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />
    </div>
  );
});

export default BasisTheoryText;
